import React from "react";
import { useDispatch } from "react-redux";

import "../RoleName/RoleName.css";
import "../OptionBlocks.css";
import {
  BalanceOff,
  BalanceCenter,
  ColumnHorizontal,
  ColumnVertical,
  GutterAlignment,
  JustifiedAlignment3,
  LeftAlignment2,
  RaggedAlignment,
  RightAlignment2,
  SideAB,
  InsetOff,
  InsetLeft,
  InsetRight,
  gutterJustify,
  SingleColumnCenter,
} from "../../../../../assets/icons/index";
import {
  updateProjectCreditOptionsState,
  saveOptionById,
} from "../../../../../Redux/actions/projectActions";

import {
  Heading,
  Subheading,
} from "../../../../ProjectV2/Options/OptionFont/Functions";

import { NumberInput, Radio, Dropdown } from "../../../../../Components";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
const initialOptions = [
  { label: "None", value: 0 },
  { label: "10%", value: 10 },
  { label: "20%", value: 20 },
  { label: "30%", value: 30 },
  { label: "40%", value: 40 },
  { label: "50%", value: 50 },
];
const Songs = ({
  options,
  currentBlockIdx,
  currentBlockId,
  undoStack,
  isCard,
}) => {
  const dispatch = useDispatch();
  const [selectedID, setSelectedID] = useState("");
  const location = useLocation();
  const [option, setOptions] = useState([...initialOptions]);
  useEffect(() => {
    const idx = option.findIndex(
      (opt) => opt.value === options?.margin_vertical,
    );
    if (idx !== -1) {
      setSelectedID(idx);
    }
  }, [options?.margin_vertical]);
  const handleChange = (key, val) => {
    switch (key) {
      case "columns":
        const new_columns = val;
        const new_column_width = Math.floor(100 / new_columns);

        dispatch(
          updateProjectCreditOptionsState(
            currentBlockIdx,
            "column_width",
            new_column_width,
          ),
        );
        dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, val));
        break;
      default:
        dispatch(updateProjectCreditOptionsState(currentBlockIdx, key, val));
    }
  };

  const conditionalColumnWidth = (val, options) => {
    const Max = 100 / options.columns;
    return parseInt(val > 0 ? (val < Max + 1 ? val : Max) : 0);
  };

  const saveOptions = () => {
    undoStack.push(options);
    dispatch(saveOptionById(currentBlockId, isCard));
  };

  const getValue = (value) => {
    return value ? value : "";
  };
  return (
    <div className="Roles-name">
      <div className="rolename-inside">
        <div className=" border-b-[1px] border-[#ffffff0e] pb-3 ">
          <div className="pt-[12px]">
            <div className="w-full font-body font-medium text-[13px] text-white ">
              Heading
            </div>
            <div className="w-full h-[46px] pt-1 rounded-2xl">
              <Heading
                onChange={(val) => {
                  handleChange("heading", val);
                }}
                value={getValue(options.heading)}
                onFocusOut={saveOptions}
              />
            </div>
          </div>

          <div className="pt-[12px]">
            <div className="w-full font-body font-medium text-[13px] text-white ">
              Sub-Heading
            </div>
            <div className="w-full h-[46px] pt-1 rounded-2xl">
              <Subheading
                onChange={(val) => {
                  handleChange("subheading", val);
                }}
                value={getValue(options.subheading ? options.subheading : "")}
                onFocusOut={saveOptions}
              />
            </div>
          </div>
        </div>
        <div className="optionSection">
          <div className="optionSectionLabel  inline-block group  cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Alignment</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the visual spacing and dividing lines between roles and
              names.
            </span>
          </div>
          <div className="optionSectionContent">
            <Radio
              options={[
                {
                  icon: SingleColumnCenter,
                  value: options.columns === 1 ? "center" : "center",
                },
                {
                  icon: LeftAlignment2,
                  value: "left",
                  disabled: options.columns === 1,
                },

                {
                  icon: RightAlignment2,
                  value: "right",
                  disabled: options.columns === 1,
                },
                {
                  icon: gutterJustify,
                  value: "gutter",
                  disabled: options.columns === 1,
                },
                {
                  icon: JustifiedAlignment3,
                  value: "justify",
                  disabled: options.columns === 1,
                },
              ]}
              value={options.text_alignment}
              onChange={(val) => {
                handleChange("text_alignment", val);
                saveOptions();
              }}
              label={options.text_alignment}
              withIcon
            />
          </div>
        </div>

        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Arrangement</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Set the number of columns to arrange the credits in.
            </span>
          </div>
          <div className="optionSectionContent ml-[-2px]">
            <NumberInput
              label="Column(s)"
              postLabel=""
              value={options.columns}
              onChange={(val) => handleChange("columns", val)}
              min={1}
              max={3}
              onFocusOut={saveOptions}
            />
          </div>
        </div>

        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Column Width</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the horizontal width of the credit block as a percentage.
            </span>
          </div>
          <div className="optionSectionContent column-widthSong">
            <NumberInput
              postLabel="%"
              value={options.column_width}
              onChange={(val) =>
                handleChange(
                  "column_width",
                  conditionalColumnWidth(val, options),
                )
              }
              min={20}
              max={100}
              onFocusOut={saveOptions}
            />
          </div>
        </div>

        {/* ============================================ */}

        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Row Gap</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Row gap
            </span>
          </div>
          <div className="optionSectionContent column-widthSong">
            <NumberInput
              // label="Bottom"
              value={options.horizontal_gap}
              min={0}
              max={50}
              onChange={(val) => handleChange("horizontal_gap", val)}
              onFocusOut={saveOptions}
            />
          </div>
        </div>

        {/* ============================================= */}

        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Balance</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Balance
            </span>
          </div>
          <div className="optionSectionContent">
            <Radio
              options={[
                {
                  icon: BalanceOff,
                  value: null,
                  disabled: options.columns === 1,
                },
                {
                  icon: BalanceCenter,
                  value: "center",
                  disabled: options.columns === 1,
                },
              ]}
              value={options.balance_columns}
              onChange={(val) => {
                handleChange("balance_columns", val);
                saveOptions();
              }}
              label={options.balance_columns === null ? "Off" : "Center"}
              withIcon
            />
          </div>
        </div>
        {/* <div className="optionSection">
          <div className="optionSectionLabel">Order</div>
          <div className="optionSectionContent">
            <Radio
              options={[
                { icon: ColumnHorizontal, value: "horizontal" },
                { icon: ColumnVertical, value: "vertical" },
              ]}
              value={options.column_flow}
              onChange={(val) => {
                handleChange("column_flow", val);
                saveOptions();
              }}
              label="Column flow"
              withIcon
            />
          </div>
        </div> */}

        {/* <hr className="border-b-2 border-white/[.6]" /> */}
        <div className="optionSection">
          <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help">Block Inset</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the horizontal indentation and padding of the block.
            </span>
          </div>
          <div className="optionSectionContent BLock-inset BLock-inset-nameonly">
            <Radio
              label={options.block_inset}
              // options={[
              //   {
              //     icon: InsetOff, value: "default",
              //     disabled: (options?.side_by_side === "on" && (options?.block_inset === "default" || options?.block_inset === "left" || options?.block_inset === "right"))
              //   },
              //   { icon: InsetLeft, value: "left" },
              //   { icon: InsetRight, value: "right" },
              //   { icon: SideAB, value: "sidebyside", disabled: options?.side_by_side === "on" },
              // ]}
              options={[
                {
                  icon: InsetOff,
                  value: "default",
                  disabled:
                    options?.side_by_side === "on" &&
                    (options?.block_inset === "default" ||
                      options?.block_inset === "left" ||
                      options?.block_inset === "right"),
                },
                {
                  icon: InsetLeft,
                  value: "left",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: InsetRight,
                  value: "right",
                  disabled: options?.side_by_side === "on",
                },
                {
                  icon: SideAB,
                  value: "sidebyside",
                  disabled: options?.side_by_side === "on",
                },
              ]}
              value={options.block_inset}
              onChange={(val) => {
                handleChange("block_inset", val);
                saveOptions();
              }}
              withIcon
            />
          </div>
        </div>
        {!isCard && (
          <div>
            <div className="optionSection">
              <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
                <span className="cursor-help">Margin</span>
                <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                  Adjust the vertical margin around the credit block.
                </span>
              </div>
              <div className="optionSectionContent block-option-content">
                <div className="label-2 label-2-roleName1440">Vertical</div>
                <Dropdown
                  // label="Vertical"
                  options={option}
                  selectedID={selectedID}
                  value={options.margin_vertical}
                  onChange={(val) => {
                    handleChange("margin_vertical", val);
                    saveOptions();
                  }}
                />
              </div>
            </div>

            <div className="optionSection">
              <div className="optionSectionContent2 block-option-content">
                <div className="optionSectionLabel inline-block group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
                  <span className="cursor-help">Bottom</span>
                  <span className="absolute hidden group-hover:block cursor-help ml-[-210px] mt-[-30px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
                    Adjust the extra spacing directly below the credit block.
                  </span>
                </div>
                <NumberInput
                  // label="Bottom"
                  value={options.extra_lines_below}
                  min={0}
                  max={25}
                  onChange={(val) => handleChange("extra_lines_below", val)}
                  onFocusOut={saveOptions}
                />
              </div>
            </div>
          </div>
        )}
        {isCard && <div></div>}
      </div>
    </div>
  );
};

export default Songs;
